import {
  WORK_DAY_CATEGORIES_FETCH_PENDING,
  WORK_DAY_CATEGORIES_REJECTED,
  WORK_DAY_CATEGORIES_FETCH,
  WORK_DAY_CATEGORIES_FETCH_MORE,
} from "../../constants";
import { REHYDRATE } from "redux-persist";
import { actionRehydrate } from "@utils";

const initialState = {
  data: {
    results: [],
  },
  isFetching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      return actionRehydrate(state, action.payload, "workDayCategories");
    case WORK_DAY_CATEGORIES_FETCH_PENDING:
      return {
        ...state,
        isFetching: true,
      };
    case WORK_DAY_CATEGORIES_REJECTED:
      return {
        ...state,
        isFetching: false,
      };
    case WORK_DAY_CATEGORIES_FETCH:
      return {
        data: action.payload.data, // Corrige para guardar el objeto recibido directamente
        isFetching: false,
      };
    case WORK_DAY_CATEGORIES_FETCH_MORE:
      return {
        ...state,
        isFetching: false,
        data: {
          ...action.payload.data,
          results: _.merge(action.payload.data.results, state.data.results),
        },
      };
    default:
      return state;
  }
}
